import React, { useMemo, useState } from "react";
import ModalUpdatePersonInItemsCanceled from "./BasketItems/ModalUpdatePersonInItemsCanceled/ModalUpdatePersonInItemsCanceled";
import ModalUpdatePersonInItemsSupplierCanceled from "./BasketItems/ModalUpdatePersonInItemsCanceled/ModalUpdatePersonInItemsSupplierCanceled";

const SelectModall = ({ show, nameModal, size, data }) => {
  switch (nameModal) {
    case 'ModalUpdatePersonInItemsCanceled':
      return <ModalUpdatePersonInItemsCanceled show2={show} size={size} data={data} />
    case 'ModalUpdatePersonInItemsSupplierCanceled':
      return <ModalUpdatePersonInItemsSupplierCanceled show2={show} size={size} data={data} />
    default:
      return '';
  }
}

const ModalManager = () => {
  const [item, setItem] = useState({ show: false, nameModal: "", size: "md" });
  const Modali = (props) => <SelectModall {...props} show={item.show} nameModal={item.nameModal} size={item.size} data={item.data} />;
  return useMemo(() => [Modali, setItem], [item]);
};
export default ModalManager;